import React, { useState, useEffect } from "react";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import { Row, Col, Card } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import RenderDeleteModal from "../../../components/partials/components/delete-modal";
import ToastNotification from "../../../components/Toast";
import { toast } from 'react-toastify';
import {
    API_AGENT_FILE_LIST,
    API_AGENT_FILE_LIST_DELETE,
    API_AGENT_FILE_LIST_DOWNLOAD,
} from "../../../service/url";
import { BACKEND_API_BASE_URL } from "../../../utilities/constant";
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { getUser } from "../../../utilities/setting";
import { DeleteIcon } from "../../../components/setting/elements";
import Loader  from '../../../components/partials/components/loader';
import { useAuth, errorCheck } from '../auth/auth-utils';
import { useNavigate } from "react-router-dom";
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import "../../../assets/custom/css/custom.css";
import exportData from '../../../utilities/export';
import { getUserAccessToken } from "../../../utilities/setting";


export default function AgentFileList() {
  const [enableDeleteModal, setEnableDeleteModal] = useState(false);
  const [deletedAgentFileId, setDeleteAgentFileId] = useState(undefined);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [agentFileList, setAgentFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [selectedData, setSelectedData] = useState([]);
  const [isMultiDelete, setIsMultiDelete] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const handleExport = async () => {
  try {
    setButtonDisable(true);

    exportToCSV({
      fileName: "agent-file-list",
      data: agentFileList,
      columns: [
        {
          header: "#",
          accessor: "key",
        },
        {
          header: "File Name",
          accessor: (row) => row.file_name || "-",
        },
        {
          header: "Uploaded By",
          accessor: (row) =>
            row.user?.username ||
            row["user.username"] ||
            row["user_id.username"] ||
            "-",
        },
        {
          header: "Created At",
          accessor: (row) =>
            new Date(row.created_at).toLocaleString(
              "en-IN",
              {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              }
            ),
        },
      ],
    });

  } finally {
    setButtonDisable(false);
  }
};

  const handleCheckboxToggle = (fileId) => {
    const isSelected = selectedData.includes(fileId);
    setSelectedData(isSelected
        ? selectedData.filter(id => id !== fileId)
        : [...selectedData, fileId]);
  };

  const handleMultiDelete = () => {
        setIsMultiDelete(true);
        setEnableDeleteModal(true);
  };

  useEffect(() => {
    setLoading(true);
    getApiCall(API_AGENT_FILE_LIST)
      .then(onAgentFileListSuccess)
      .catch(onError)
      .finally(() => setLoading(false));
  }, []);


  function onAgentFileListSuccess(resp) {
    // getApiCall returns response.data.data directly
    const responseData = Array.isArray(resp) ? resp : [];
    const updatedList = responseData.map((val, idx) => {
      val["key"] = idx + 1;
      val["created_at"] = new Date(val["created_at"]).toGMTString();
      return val;
    });
    setAgentFileList(updatedList);
  }

  const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});

    useEffect(() => {
      const user = getUser();
        if (user) {
          if (user?.acl_settings) {
            setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
          }
        }
    }, []);

    useEffect(() => {
      const onAclRefreshed = () => {
        const user = getUser();
        if (user?.acl_settings?.module_operations) {
          try {
            const parsed = typeof user.acl_settings.module_operations === "string"
              ? JSON.parse(user.acl_settings.module_operations)
              : user.acl_settings.module_operations;
            setModuleOperationsForReadPermissionCheck(parsed);
          } catch (e) {
            console.log("Failed to apply refreshed ACL", e);
          }
        }
      };
      window.addEventListener("acl-refreshed", onAclRefreshed);
      return () => window.removeEventListener("acl-refreshed", onAclRefreshed);
    }, []);

  const RenderActionComponent = ({id}) => {
    return (
      <div className="flex align-items-center list-user-action">
          <DeleteIcon handleCallback={() => handleAgentFileListDelete(id)} />
      </div>
    );
  };

  function handleAgentFileListDelete(id) {
    checkAuth(setToastProps, setShowToast)
    setIsMultiDelete(false);
    setEnableDeleteModal(true);
    setDeleteAgentFileId(id);
  }

  const handleSelectAll = () => {
    if (selectedData.length === agentFileList.length) {
        setSelectedData([]);
    } else {
        const allFilesIds = agentFileList.map(agentFileList => agentFileList.id);
        setSelectedData(allFilesIds);
    }
  };

  useEffect( () => {
    if (confirmDelete) {
        if (isMultiDelete) {
            postApiCall(API_AGENT_FILE_LIST_DELETE, { fileListIds: selectedData })
                .then(onDeleteSuccess)
                .catch(onDeleteFail);
        } else {
            postApiCall(API_AGENT_FILE_LIST_DELETE, { fileListIds: [deletedAgentFileId] })
                .then(onDeleteSuccess)
                .catch(onDeleteFail);
        }
    }
    }, [confirmDelete]);

  function onDeleteSuccess(resp) {
    toast.success("File deleted successfully");
    let updatedList;
    if (isMultiDelete) {
        updatedList = agentFileList.filter(val => !selectedData.includes(val.id)).map((val, key) => {
            val['key'] = key + 1;
            return val;
        });
        setSelectedData([]);
    } else {
        updatedList = agentFileList
        .filter((val) => val.id != deletedAgentFileId)
        .map((val, key) => {
          val["key"] = key + 1;
          return val;
        });
    }

    setLoading(true);
    getApiCall(API_AGENT_FILE_LIST)
      .then(onAgentFileListSuccess)
      .catch(onError)
      .finally(() => setLoading(false));
      
    setAgentFileList(updatedList);
    setEnableDeleteModal(false);
    setDeleteAgentFileId(undefined);
    setConfirmDelete(false); 
  }

  function onDeleteFail(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
    } else {
      toast.warning(`Unable to delete File: ${err}`);
    }
    setConfirmDelete(false); 
   
  }

  function onError(err) {
    if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
      errorCheck(err, navigate, setToastProps, setShowToast)
   } else {
     console.log(err)
   }
 }

 const rowClassName = (data) => {
  return {
      'highlighted-row': selectedData.includes(data.id)
    };
  }


  const actionBodyTemplate = (rowData) => {
    return <RenderActionComponent id={rowData.id} />;
  };

  const handleDownloadFile = async (fileId, fileName) => {
    try {
      const token = getUserAccessToken();
      const downloadUrl = `${BACKEND_API_BASE_URL}${API_AGENT_FILE_LIST_DOWNLOAD}/${fileId}`;
      
      const response = await fetch(downloadUrl, {
        method: 'GET',
        headers: {
          'Authorization': token
        }
      });

      if (!response.ok) {
        throw new Error('Failed to download file');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
       toast.error(`Failed to download file: ${error.message}`);
    }
  };

  const fileUrlBodyTemplate = (rowData) => {
    return (
      <a 
        href="#" 
        onClick={(e) => {
          e.preventDefault();
          handleDownloadFile(rowData.id, rowData.file_name);
        }}
        style={{ color: '#007bff', textDecoration: 'underline', cursor: 'pointer' }}
      >
        {rowData.file_name}
      </a>
    );
  };

  if (loading) {
    return <Loader />
  }

  return (
    <>
      <div>
        <Row>
          <Col sm="12">
            <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">Agent File List</h4>
              </div>
            </Card.Header>
              <Card.Body className="px-0">
                <div className="scroll-container">
                  <div className="table-responsive border-bottom my-3">
                    <Button 
                      label="Delete Selected" 
                      onClick={handleMultiDelete} 
                      className="p-button-danger p-button-sm" 
                      style={{ marginBottom: '10px', marginLeft: '10px' }} 
                      disabled={selectedData.length === 0} 
                    />
                    { agentFileList.length > 0 &&
                      <Button 
                      label="Export Data" 
                      onClick={handleExport} 
                      className="p-button-active p-button-sm" 
                      style={{ marginBottom: '10px', marginLeft: '10px' }} 
                      disabled={buttonDisable} 
                    >
                      &nbsp;
                      {buttonDisable && (
                          <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                      )}
                    </Button>}

                    <DataTable
                      value={agentFileList}
                      tableStyle={{ minWidth: "50rem" }}
                      paginator
                      rows={8}
                      rowClassName={rowClassName}
                    >
                      <Column 
                        header={<Checkbox 
                        checked={selectedData.length === agentFileList.length && agentFileList.length > 0} 
                        onChange={handleSelectAll} 
                        />} 
                        headerStyle={{ width: '3rem' }} 
                        body={(rowData) => (
                        <Checkbox 
                          checked={selectedData.includes(rowData.id)} 
                          onChange={() => handleCheckboxToggle(rowData.id)} 
                        />
                        )} 
                      />
                      <Column 
                        field="file_url" 
                        header="Agent File Url" 
                        body={fileUrlBodyTemplate}
                      ></Column>
                      <Column
                        field="user.username"
                        header="Username (Uploaded By)"
                        body={(rowData) => {
                          // Handle both user.username and user_id.username formats
                          return rowData.user?.username || rowData['user.username'] || rowData['user_id.username'] || '';
                        }}
                      ></Column>
                      <Column 
                        field="created_at" 
                        header="Created At" 
                        body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                      <Column header="Action" body={actionBodyTemplate} />
                    </DataTable>
                  </div>
                </div>
              </Card.Body>

            </Card>
          </Col>
        </Row>
      </div>

      <RenderDeleteModal 
         show={enableDeleteModal} 
         setShow={setEnableDeleteModal} 
         setConfirmDelete={setConfirmDelete} 
         isMultiDelete={isMultiDelete} 
         clearSelectedData={() => setSelectedData([])}
      />
    </>
  );
};
